import { Injectable } from '@angular/core';
import { HttpClientService } from '../http-client/http-client.service';
import { Subscriber } from 'rxjs/Subscriber';
import { Service } from '../service';
import { Observable } from 'rxjs/Observable';
import { EmployeeAttr } from '../../models/config/employee-attr';
import { StudentAttr } from '../../models/config/student-attr';


@Injectable()
export class ConfigService extends Service {

    public employeeAttrs: EmployeeAttr[];
    public employeeAttrsObject: any;

    public studentAttrs: StudentAttr[];
    public studentAttrsObject: any;

    constructor(
        private http: HttpClientService
    ) {
        super();
        this.employeeAttrs = [];
        this.employeeAttrsObject = {};
        this.studentAttrs = [];
        this.studentAttrsObject = {};
    }

    public getEmployeeAttrs(): Observable<EmployeeAttr[]> {
        if (!!this.employeeAttrs && this.employeeAttrs.length > 0) {
            return Observable.create((observer: Subscriber<EmployeeAttr[]>) => {
                observer.next(this.employeeAttrs);
                observer.complete();
            });
        }
        const url = 'config/employeeAttrs';
        return this.http.get(url).map(response => {
            const r = response.json();
            if (r.ResultCode === 1) {
                this.employeeAttrs = r.Result;
                console.log('this.events', this.employeeAttrs);
                this.employeeAttrsObject = this.employeeAttrs.reduce((result, s) => {
                    result[String(s.Code)] = result[String(s.Code)] || {};
                    result[String(s.Code)] = s;
                    return result;
                }, {});
            } else {
                console.error('CurriculumService > getAll > response', r);
            }
            return this.employeeAttrs;
        }).catch(this.handleError);
    }

    public getStudentAttrs(): Observable<EmployeeAttr[]> {
        if (!!this.studentAttrs && this.studentAttrs.length > 0) {
            return Observable.create((observer: Subscriber<EmployeeAttr[]>) => {
                observer.next(this.studentAttrs);
                observer.complete();
            });
        }
        const url = 'config/studentAttrs';
        return this.http.get(url).map(response => {
            const r = response.json();
            if (r.ResultCode === 1) {
                this.studentAttrs = r.Result;
                console.log('this.events', this.studentAttrs);
                this.studentAttrsObject = this.studentAttrs.reduce((result, s) => {
                    result[String(s.Code)] = result[String(s.Code)] || {};
                    result[String(s.Code)] = s;
                    return result;
                }, {});
            } else {
                console.error('ConfigService > getStudentAttrs > response', r);
            }
            return this.studentAttrs;
        }).catch(this.handleError);
    }
}



// WEBPACK FOOTER //
// ./src/app/main/services/config/config.service.ts